export default function HomePanel(props) {
    return (
        <div className="kwizda-home-panel" style={{display:"block", width:'95%'}}>
            <div className="kwizda-home-panel1">
            Hobbikertje van és nem hisz a bio módszerek és készítmények működésében? Szkeptikus a vegyszerek nélküli növényvédelemmel kapcsolatban? Kíváncsi a valós tapasztalatokra?
            Csatlakozzon hozzánk, próbálja ki a biológiai növényvédelem vívmányait, megoldásait és az erre nemesített növényeket!
            Érdemes jelentkezni „on garden” kísérleteinkre, mert ingyenesen tesztelheti a legjobb termékeinket és megoszthatja tapasztalatait másokkal. Amennyiben megfelel a követelményeknek és a szabályok szerint dokumentálja a kísérletet, akkor díjmentesen juthat termékeinkhez. Sőt még garantált ajándékokban is részesül!
            Győződjön meg a bio megoldások erejéről és adja tovább tapasztalatait!
            </div>
            <div className="kwizda-home-panel2">
                <button className="kwizda-home-registerbutton" onClick={()=>props.register()}>
                    {!props.isItemPage? "Regisztrálok": "Regisztrálok erre a kísérletre"}</button>
            </div>
        </div>
    )
  }